import { tv } from "tailwind-variants";

export const getBulletListClass = tv({ base: "" });

export const getListClass = tv({ base: ["flex w-full flex-col gap-1 text-gray-700 lg:gap-2"] });

export const getListItemClass = tv({ base: ["flex items-start gap-2 leading-relaxed lg:text-xl"] });
